import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, Pagination, TableHead, TableRow, Dialog, Box, TextField, Menu, MenuItem } from '@mui/material'
import { useSelector } from 'react-redux';
import { useAuthContext } from '../hooks/adminAuthHook'
import toast from 'react-hot-toast'
import BookingsHook from '../hooks/BookingHook';
import {DownloadBookings} from '../downloadingHooks/BookingsCSV'
export default function Bookings() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { getBookings } = BookingsHook();
    const { admin } = useAuthContext()

    useEffect(() => {
        getBookings()
        document.title = "Bookings"
    }, [])
    const collapsed = useSelector((state) => state.collapsed.collapsed);
    const bookings = useSelector((state) => state.bookings.bookings);
    const [search, setSearch] = useState("");
const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  // Handle search input change
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };



 // custom date range filter
 const [openModal, setOpenModal] = useState(false);

 const handleClickOpenModal = () => {
     setOpenModal(true);
 };

 const handleCloseModal = () => {
     setOpenModal(false);

 }
  
 const [dateFrom, setDateFrom] = useState('')
 const [dateTo, setDateTo] = useState('')
 const [filterValue, setFilterValue] = useState('')

 // Getting filtered registered agencies
 const today = new Date();

 const sevenDaysAgo = new Date();
 sevenDaysAgo.setDate(today.getDate() - 7);

 const isWithinFilter = (data) => {
     const dataCreatedAt = new Date(data.createdAt);
     const today = new Date();
     const sevenDaysAgo = new Date();
     sevenDaysAgo.setDate(today.getDate() - 7);

     // Ensure date strings are converted to Date objects and are valid
     const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

     if (filterValue === 'today') {
         return dataCreatedAt.toDateString() === today.toDateString();
     } else if (filterValue === 'thisWeek') {
         return dataCreatedAt >= sevenDaysAgo && dataCreatedAt <= today;
     } else if (filterValue === 'custom') {
         // Handle empty strings gracefully
         const fromDate = dateFrom ? new Date(dateFrom) : undefined;
         const toDate = dateTo ? new Date(dateTo) : undefined;
         if (!isValidDate(fromDate) || !isValidDate(toDate)) {

             return false;
         }

         // Check if agencyCreatedAt is within the custom date range
         return dataCreatedAt >= fromDate && dataCreatedAt <= toDate;
     } else {
         return true; // 'all' case or any other default case
     }
 }
    const filteredBookings = bookings?.filter((agency) => {
        const searchTerm = search.toLowerCase();
        const matchesSearch=(
            agency.packageName?.toLowerCase().includes(searchTerm) ||
            agency.agencyName?.toLowerCase().includes(searchTerm)
        )

        return matchesSearch&&isWithinFilter(agency);
    });

    const paginatedBookings = filteredBookings && filteredBookings.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
      );
   

      
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open1 = Boolean(anchorEl);
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const menuStyles = {
        borderRadius: '4px',
        backgroundColor: '#fff',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
    };

    const menuItemStyles = {
        padding: '4px 12px',
        fontSize: '12px',
        color: '#000',
        cursor: 'pointer'
    };

    const menuItemHoverStyles = {
        backgroundColor: '#f5f5f5'
    };


 return (
        <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
            <div className="container-fluid bg-none my-0 mt-0">
                <div className="row px-2 mt-5 pt-3">
                    <div className="col-md-12 data_table p-2 pb-3">
                        <div className="d-flex justify-content-between searchbar pb-2 pt-2 px-md-2 my-auto">
                            <div className="d-flex left my-auto mb-2 mb-md-0 ps-2 ps-md-0">
                                <h6>Bookings</h6>
                            </div>
                            <div className="d-flex right my-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 search_icon_svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                </svg>
                                <input type="text" value={search} onChange={handleSearchChange} placeholder='Seacrh..' />
                                 {/* Filters button */}
                                 <button className="filter_btn" id="basic-button" aria-controls={open1 ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open1 ? 'true' : undefined} onClick={handleClick1}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                                    </svg>
                                </button>
                                <button className="filter_btn" onClick={()=>DownloadBookings(filteredBookings)}>
                                <i className="fa-solid fa-download"></i>
                                </button>
                                
                                {/* Menu for filter options */}
                                <Menu id="basic-menu" anchorEl={anchorEl} open={open1} onClose={handleClose1} MenuListProps={{ 'aria-labelledby': 'basic-button', style: menuStyles }}>
                                    <MenuItem onClick={() => { handleClose1(); setFilterValue(''); setDateFrom(''); setDateTo('') }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        All
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleClose1(); setFilterValue('today'); setDateFrom(''); setDateTo('') }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        Today
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleClose1(); setFilterValue('thisWeek'); setDateFrom(''); setDateTo('') }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        This Week
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleClickOpenModal(); setFilterValue('custom');handleClose1()}} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        Custom Date
                                    </MenuItem>
                                    <MenuItem onClick={() => { setFilterValue(''); setDateFrom(''); setDateTo('');handleClose1() }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        Default
                                    </MenuItem>
                                </Menu>
                            </div>
                        </div>
                        <TableContainer>
                            <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table" className='text-center'>
                                <TableHead >
                                    <TableRow >
                                        <TableCell className='th text-center' >ID</TableCell>
                                        {/* <TableCell className='th text-center'>Booking No</TableCell> */}
                                        <TableCell className='th text-center'>Date</TableCell>
                                        <TableCell className='th text-center'>Package Name</TableCell>
                                        <TableCell className='th text-center'>Head Name</TableCell>
                                        <TableCell className='th text-center'>Agency Name</TableCell>
                                        <TableCell className='th text-center'>Price</TableCell>
                                        <TableCell className='th text-center'>No. of perople</TableCell>
                                        {/* <TableCell className='th text-center'>Action</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {filteredBookings && filteredBookings.length > 0 ? (
                                        filteredBookings.map((data, index) => (
                                            <React.Fragment key={index}>
                                                <TableRow className="table_row">
                                                    <TableCell className="text-center td">{index + 1}</TableCell>  
                                                    {/* <TableCell className="text-center td">UY786499</TableCell> */}
                                                    <TableCell className="text-center td">{new Date(data.createdAt).toLocaleString()}</TableCell>
                                                    <TableCell className="text-center td">{data.packageName}</TableCell>
                                                    
                                                    <TableCell className="text-center td">{data.headName}</TableCell>
                                                    <TableCell className="text-center td">{data.agencyName}</TableCell>
                                                    <TableCell className="text-center td">{data.totalPrice?.toLocaleString()}</TableCell>
                                                    <TableCell className="text-center td">{data.totalMembers}</TableCell>
                                        
                                                    <TableCell className="text-center td">{data.totalBookings}</TableCell>
                                                    <TableCell className="text-center td">
                                                       
                                                    </TableCell>
                                                    <TableCell className="text-center td">
                                                        
                                                    </TableCell>
                                                </TableRow>
                                                <hr />
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <TableRow className="table_row" sx={{ marginBottom: 2 }}>
                                            <TableCell colSpan={3} className="text-center td"></TableCell>
                                            <TableCell className="text-center td">No result</TableCell>
                                            <TableCell colSpan={3} className="text-center td"></TableCell>
                                        </TableRow>
                                    )}
                                </TableBody >
                            </Table>
                        </TableContainer>
                         {/* Pagination */}
                                      <div className="d-flex justify-content-end mt-3">
                                        <Pagination
                                          count={Math.ceil(paginatedBookings.length / rowsPerPage)}
                                          page={page}
                                          onChange={handlePageChange}
                                          className="custom-pagination"
                        
                                        />
                                      </div>
                    </div>
                </div>
            </div>

              {/* Custom Date Range Modal */}
              <Dialog className='custom_date_modal p-0'
                open={openModal}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <div className="container-fluid">
                    <div className="row ">
                        <div className="col-md-12 text-center pb-2 px-0 m-0">
                            <div className="content px-4 text-center">
                                <h6 className='my-3 '>Custom filter!</h6>
                                <Box
                                    component="form"
                                    sx={{
                                        '& .MuiTextField-root': { m: 0.5, width: '15ch' },  // Reduced margin
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div>
                                        <TextField
                                            id="date-from"
                                            label="Date From"
                                            type="date"
                                            value={dateFrom}
                                            onChange={(e) => setDateFrom(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,  // Ensures label doesn't overlap with date input
                                            }}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '35px' },  // Minimize height
                                                '& .MuiInputLabel-root': { fontSize: '12px' }, // Minimize label font size
                                                '& .MuiInputBase-input': { fontSize: '12px' }  // Minimize input text font size
                                            }}
                                        />
                                        <TextField
                                            id="date-to"
                                            label="Date To"
                                            type="date"
                                            value={dateTo}
                                            onChange={(e) => setDateTo(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,  // Ensures label doesn't overlap with date input
                                            }}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '35px' },  // Minimize height
                                                '& .MuiInputLabel-root': { fontSize: '12px' }, // Minimize label font size
                                                '& .MuiInputBase-input': { fontSize: '12px' }  // Minimize input text font size
                                            }}
                                        />
                                    </div>
                                </Box>
                            </div>
                            <button className="cancel m-1 py-1 px-2" onClick={() => { handleCloseModal(); setDateFrom(''); setDateTo(''); setFilterValue('') }}>Cancel</button>
                            <button className="m-1 py-1 px-2 active" onClick={handleCloseModal}>Filter</button>
                        </div>
                    </div>
                </div>

            </Dialog>

        </div >
    )
}
